<!-- modified primevue PanelMenuSub component -->
<template>
  <ul class="p-submenu-list" :class="listClass" role="tree">
    <template v-for="(item, i) of model" :key="label(item) + i.toString()">
      <li role="none" :class="getItemClass(item)" :style="item.style" v-if="visible(item) && !item.separator">
        <template v-if="isGroup(item)">
          <button type="button" class="sb-group-row" :aria-expanded="isActive(item) ? 'true' : 'false'"
            @click="onItemClick($event, item)">
            <span v-if="item.icon" :class="['sb-ico', item.icon]"></span>
            <span class="sb-txt">{{ label(item) }}</span>
            <svg class="sb-chev" :class="{ 'is-open': isActive(item) }" width="13" height="13" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="sb-sub" v-show="isActive(item)">
            <AppPanelMenuSub v-if="item.items" :key="label(item) + '_sub_'" list-class="sb-pages" :template="template"
              :model="item.items" :expandedKeys="expandedKeys" @itemToggle="$emit('itemToggle', $event)"
              :exact="exact" />
          </div>
        </template>
        <template v-else-if="!template">
          <router-link v-if="item.to && !disabled(item)" :to="item.to" custom
            v-slot="{ navigate, href, isActive: isRouterActive, isExactActive }">
            <a :href="href" :class="linkClass(item, { isActive: isRouterActive, isExactActive })"
              @click="onItemClick($event, item, navigate)" role="treeitem">
              <span class="sb-page-txt">{{ label(item) }}</span>
            </a>
          </router-link>
          <a v-else :href="item.url" :class="linkClass(item)" :target="item.target" @click="onItemClick($event, item)"
            role="treeitem" :tabindex="disabled(item) ? null : '0'">
            <span class="sb-page-txt">{{ label(item) }}</span>
          </a>
        </template>
        <component v-else :is="template" :item="item"></component>
      </li>
      <li :class="['p-menu-separator', item.class]" :style="item.style" v-if="visible(item) && item.separator"
        :key="'separator' + i.toString()"></li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'AppPanelMenuSub',
  emits: ['itemToggle'],
  props: {
    model: {
      type: null,
      default: null
    },
    template: {
      type: Function,
      default: null
    },
    expandedKeys: {
      type: null,
      default: null
    },
    exact: {
      type: Boolean,
      default: true
    },
    listClass: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeItem: null
    }
  },
  methods: {
    onItemClick(event, item, navigate) {
      if (this.isActive(item) && this.activeItem === null) {
        this.activeItem = item;
      }

      if (this.disabled(item)) {
        event.preventDefault();
        return;
      }

      if (item.command) {
        item.command({
          originalEvent: event,
          item: item
        });
      }

      if (item.to && navigate) {
        navigate(event);
        return;
      }

      if (this.activeItem && this.activeItem === item)
        this.activeItem = null;
      else
        this.activeItem = item;

      this.$emit('itemToggle', { item: item, expanded: this.activeItem != null });
    },
    isGroup(item) {
      return !!(item.items && !item.to);
    },
    getItemClass(item) {
      return [this.isGroup(item) ? 'sb-group' : 'sb-page-item', item.className];
    },
    linkClass(item, routerProps) {
      const isActiveByPaths = item.activePaths && Array.isArray(item.activePaths) && item.activePaths.includes(this.$route.path);
      const isActive = (routerProps && routerProps.isActive) || isActiveByPaths;
      const isExactActive = (routerProps && routerProps.isExactActive) || isActiveByPaths;
      return ['sb-page', {
        'p-disabled': this.disabled(item),
        'router-link-active': isActive,
        'router-link-active-exact': this.exact && isExactActive
      }];
    },
    isActive(item) {
      return this.expandedKeys ? this.expandedKeys[item.key] : item === this.activeItem;
    },
    visible(item) {
      return (typeof item.visible === 'function' ? item.visible() : item.visible !== false);
    },
    disabled(item) {
      return (typeof item.disabled === 'function' ? item.disabled() : item.disabled);
    },
    label(item) {
      return (typeof item.label === 'function' ? item.label() : item.label);
    }
  }
}
</script>
